module.exports = __webpack_public_path__ + "img/addb.77c435ed.svg";